import React from 'react';
import Version from './Version.js'
import RightLinks from './RightLinks.js'

class Footer extends React.Component {

  render () {
		return (<div className="row">
      <div className="col-12 text-center pt-3"><hr style={{border:"1px dashed rgba(0, 0, 0, 0.05)"}}/></div>
      <div className="col-12 text-center p-0"><small className="text-muted"><a rel="noopener noreferrer" target="_blank" className="text-muted" href="https://www.guppyi.com">guppyi - sports scoreboard</a> | Version : <Version/> | ©2020 <a rel="noopener noreferrer" target="_blank" className="text-muted" href="http://www.incast.de">Incast GmbH</a></small></div>
      <div className="col-12 text-center p-0"><small className="text-muted"><RightLinks/></small></div>
    </div>)
  }
}
export default Footer;
